import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";
import {markRaw} from 'vue'
import FormattedTime from 'frontend/common/formatted-time.vue'

export const DayLabelDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name',
    'description',
    'background_color',
    'border_color',
    'font_color',
    'updated_at',
  ],
  subscriptions: {
    items: 'DayLabelsChannel',
  },
  defaultColumns: [
    'name',
    'description',
    'label'
  ],
  columnConfig: {
    name: {
      label: 'Name',
      header: {
        sort: 'lower_name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
        class: 'text-nowrap',
      },
    },
    description: {
      label: 'Description',
      header: {
        sort: 'description',
      },
      cell: {
        kind: 'simple',
        path: 'description',
      },
    },
    label: {
      label: 'Label',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'component',
        component: 'erebus-label',
        componentProps: c => ({ item: c }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
        }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: markRaw(FormattedTime),
        componentProps: entry => ({
          t: entry.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
  }
}